import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-vertical-align-bottom",
  templateUrl: "./med-icon-vertical-align-bottom.component.html",
})
export class MedIconVerticalAlignBottomComponent extends SvgMixinComponent {}
